/* eslint-disable */
import React, { ReactNode } from 'react';

import { useStyles } from './typography.styles';
import clsx from 'clsx';

export interface InfoProps {
  children?: ReactNode; // PropTypes.node
}

export const Info = (props: InfoProps) => {
  const classes = useStyles();
  const { children } = props;
  return (
    <div className={clsx(classes.defaultFontStyle, classes.infoText)}>
      {children}
    </div>
  );
};
